import { Footer } from '@/components/Footer'
import { PrivacyPolicy } from '@/components/PrivacyPolicy'
import { SEO } from '@/components/SEO'
import { SEO_CONFIG } from '@/constants/seo'

export const PrivacyPolicyPage = () => {
    return (
        <>
            <SEO
                title='Privacy Policy - Nexly'
                description='Read Nexly privacy policy to understand how we collect, use, and protect your financial data. We prioritize client data security and privacy.'
                canonical={`${SEO_CONFIG.siteUrl}/privacy-policy`}
                ogImage={SEO_CONFIG.ogImage}
            />
            <PrivacyPolicy/>
            <Footer/>
        </>
    )
}
